import { NgModule } from '@angular/core';
import { KeyboardAttachDirective } from './keyboard-attach/keyboard-attach';
@NgModule({
	declarations: [KeyboardAttachDirective],
	imports: [],
	exports: [KeyboardAttachDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts